import flat from 'flat';

export function findValueByKeyDeep<T>(key: string, obj: Record<string, unknown>): T | undefined {
  if (!obj) obj = {};
  const flattened: Record<string, unknown> = flat(obj);
  const found = Object.keys(flattened).find((__key__) => __key__.includes(key));
  if (!found) return undefined;
  return flattened[found] as T;
}
